import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=12a94c8c&scoped=true"
import script from "./TitlePage.vue?vue&type=script&lang=js"
export * from "./TitlePage.vue?vue&type=script&lang=js"
import style0 from "./TitlePage.vue?vue&type=style&index=0&id=12a94c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a94c8c",
  null
  
)

export default component.exports